var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-badge",class:("status-badge--" + (_vm.status.toLowerCase()))},[(_vm.title)?_c('span',{staticClass:"status-badge__text"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }